import { useEffect } from 'react';

// This solution disables changing values for every input with numeric type when users focus on the inputs and try to scroll
const useDisableNumberInputScroll = () => {
  useEffect(() => {
    const disableScroll = () => {
      const el = document.activeElement;

      if (el instanceof HTMLInputElement && el.type === 'number') {
        el.blur();
      }
    };

    window.addEventListener('wheel', disableScroll);

    return () => {
      window.removeEventListener('wheel', disableScroll);
    };
  }, []);
};

export default useDisableNumberInputScroll;
